import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { adminCustomersFeatureFlagsReducers, adminCustomersFeatureFlagsWatchers } from './feature-flags';
import { adminCustomersLockAllUsersReducers, adminCustomersLockAllUsersWatchers } from './lock-all-users';

export const adminCustomersByIdReducers = combineReducers({
	featureFlags: adminCustomersFeatureFlagsReducers,
	lockAllUsers: adminCustomersLockAllUsersReducers
});

export const adminCustomersByIdWatchers = combineAllWatchers([
	adminCustomersFeatureFlagsWatchers,
	adminCustomersLockAllUsersWatchers
]);
